<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import {getInjector, getLocalization} from 'core/svelte-context/context';
    import {KpDocumentDetailPageService} from '../kp-document-detail-page.service';
    import {getPageContext} from 'shared/layouts/page-context';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    const localize = getLocalization();
    const service = getInjector().getByClass(KpDocumentDetailPageService);

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;
    const navigationButtons = service.createNavigationButtons(model.record);
</script>

{#if navigationButtons.showAny()}
    <div class="navigation-buttons-container">
        {#if navigationButtons.showBack()}
            <a class="back-to-search-button" href={navigationButtons.getBackLink()}>
                <IconedContent gap="3px" icon="angle-double-small-left">
                    {localize(/* @kp-localization detail.zpetNaVyhledane */ 'detail.zpetNaVyhledane')}
                </IconedContent>
            </a>
        {/if}

        <a class="previous-button"
           href={navigationButtons.getPreviousPath()}
           class:disabled={!navigationButtons.showPrevious()}>

            <IconedContent gap="3px" icon="angle-small-left">
                {localize(/* @kp-localization commons.Predchozi */ 'commons.Predchozi')}
            </IconedContent>
        </a>

        <a class="next-button"
           href={navigationButtons.getNextPath()}
           class:disabled={!navigationButtons.showNext()}>

            <IconedContent gap="3px" icon="angle-small-right">
                {localize(/* @kp-localization commons.Nasledujici */ 'commons.Nasledujici')}
            </IconedContent>
        </a>
    </div>
{/if}

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    @navigation-buttons-height: 38px;

    .navigation-buttons-container {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border: 1px solid @table-border-color;
        border-radius: @border-radius-base;
        -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);

        a {
            display: flex;
            align-items: center;
            justify-content: center;
            height: @navigation-buttons-height;
            padding: 0 @padding-small-horizontal;
            color: inherit;
            line-height: 1.2;
            transition: opacity 0.3s ease-in-out, background-color 0.3s ease-in-out;

            &:hover {
                opacity: 0.7;
                text-decoration: none;
                background-color: rgba(18, 57, 255, 0.15);
            }

            &.back-to-search-button {
                width: 100%;
                border-top-left-radius: @border-radius-base;
                border-top-right-radius: @border-radius-base;
                border-bottom: 1px solid @table-border-color;
            }

            &.previous-button {
                border-bottom-left-radius: @border-radius-base;
                border-right: 1px solid @table-border-color;
            }

            &.next-button {
                border-bottom-right-radius: @border-radius-base;
            }

            &.previous-button,
            &.next-button {
                width: 50%;
            }

            &.disabled {
                opacity: 0.7;
                pointer-events: none;
                cursor: not-allowed;
            }
        }
    }
</style>